import React, { useState, useEffect, useContext } from 'react'
import _, { size } from 'lodash'
import { Form, Col, Row } from 'antd'
import useFormPersist from '../utils/useFormPersist'
import { substeps } from '../assets/constants'
import { Button, SaltaButton } from './buttons'
import moment from 'moment'
import axios from 'axios'
import { getAnnuncio, buildPropertyFromDraft } from '../utils/mapping'
import { useParams } from 'react-router-dom'
import TagManager from 'react-gtm-module'
import { StepContext } from '../utils/StepContext'
import LoadingOverlay from 'react-loading-overlay-ts'

const validateMessages = {
  required: 'Campo obbligatorio',
}

const tagManagerArgs = (userId, last_step) => {
  return {
    dataLayer: {
      userId,
      last_step,
      event: 'stepCreateListing',
    },
    dataLayerName: 'dataLayer',
  }
}

const saveDraft = async (formValue, addValue, _draft, step, isEditing) => {
  if (_.size(_draft) > 0) {
    const property = getAnnuncio({
      formValue,
    })
    const draft = {}
    _.each(
      _draft,
      (draftItem) => (draft[draftItem] = _.get(property, draftItem))
    )
    draft.id = formValue.id
    draft.last_step = `${step.masterStep} - ${step.subStep}`
    let draftResult = {}
    if (!formValue.id) {
      const { data: { data: draftRes } = {} } = await axios.post(
        `${process.env.REACT_APP_API_URL}/api/propertylisting/create`,
        {
          ...draft,
          isDraft: true,
          draftChange: true,
        }
      )
      addValue({
        id: draftRes.id,
      })
      draftResult = draftRes
    } else {
      const { data: { data: draftRes } = {} } = await axios.post(
        `${process.env.REACT_APP_API_URL}/api/propertylisting/create`,
        {
          ...draft,
          isDraft: true,
          draftChange: true,
        }
      )
      draftResult = draftRes
    }
    const propertyFromDraft = buildPropertyFromDraft(draftResult[0])
    addValue({
      ...propertyFromDraft,
    })
  }
  return null
}

const modifyProperty = async (formValue, addValue, _draft, step, isEditing) => {
  if (_.size(_draft) > 0) {
    const property = getAnnuncio({
      formValue,
    })
    const draft = {}
    _.each(
      _draft,
      (draftItem) => (draft[draftItem] = _.get(property, draftItem))
    )
    draft.id = formValue.id
    draft.last_step = `${step.masterStep} - ${step.subStep}`
    let draftResult = {}
    const { data: { data: draftRes } = {} } = await axios.post(
      `${process.env.REACT_APP_API_URL}/api/propertylisting/modify`,
      {
        ...draft,
        draftChange: true,
      }
    )
    draftResult = draftRes
    const propertyFromDraft = buildPropertyFromDraft(draftResult[0])
    addValue({
      ...propertyFromDraft,
    })
  }
  return null
}

const saveSteps = (formValue, masterStep, subStep) => {
  const draft = {
    id: formValue.id,
    last_step: `${masterStep} - ${subStep}`,
  }
  axios.post(`${process.env.REACT_APP_API_URL}/api/propertylisting/create`, {
    ...draft,
    isDraft: true,
    draftChange: false,
  })
}

const FormComponent = (props) => {
  const fields = _.get(
    substeps,
    `[${props.masterStepValue}].steps.[${props.stepValue}].fields`,
    []
  )
  const draft = _.get(
    substeps,
    `[${props.masterStepValue}].steps.[${props.stepValue}].draft`,
    []
  )
  const skip = _.get(
    substeps,
    `[${props.masterStepValue}].steps.[${props.stepValue}].skip`,
    []
  )
  const canSkip = _.get(
    substeps,
    `[${props.masterStepValue}].steps.[${props.stepValue}].canSkip`,
    false
  )
  const btnDisabled = _.get(
    substeps,
    `[${props.masterStepValue}].steps.[${props.stepValue}].btnDisabled`,
    false
  )
  const bntLabel = _.get(
    substeps,
    `[${props.masterStepValue}].steps.[${props.stepValue}].btnLabel`,
    'Conferma e Procedi'
  )
  const { propertyId: _propertyId, draftId } = useParams()
  const propertyId = _propertyId || draftId
  const [form] = Form.useForm()
  const [componentSize, setComponentSize] = useState('large')
  const [stepToRecheck, setStepToRecheck] = useState([])
  const { formValue, addValue, removeValue } = useFormPersist({
    permanenza: '3',
    refunded: '1',
    prenotazioneData: moment().toISOString(true),
    ...props.draft,
  })
  const { handleGoToStep, step, getCurrentStep, countedStepsLenght } =
    useContext(StepContext)

  const [returnBack, setReturnBack] = useState(false)
  const [loading, setLoading] = useState(false)
  const [loaderEnabled, setLoaderEnabled] = useState(false)

  const handleLoaderEnabled = (value) => {
    setLoaderEnabled(value)
  }

  const setLoadingIfEnabled = (value) => {
    if (loaderEnabled) {
      setLoading(value)
    }
  }

  useEffect(() => {
    if (typeof skip === 'function') {
      const isToSkip = async () => {
        const result = await skip(formValue, addValues, props.editing)
        if (result) {
          removeValue(fields)
          if (returnBack) {
            props.decrementStep()
            setReturnBack(false)
          } else {
            const shiftedStep = shiftRecheck()
            setReturnBack(true)
            if (_.size(shiftedStep) === 0 && props.editing) {
              props.setEditing(false)
              props.goToRiepilogo()
            } else if (_.size(shiftedStep) > 0) {
              props.goToStep(shiftedStep[0])
            } else {
              props.incrementStep()
            }
          }
        }
      }
      isToSkip()
    }
    if (
      !props.editing &&
      !propertyId &&
      !returnBack &&
      !(props.masterStepValue === 0 && props.stepValue === 0)
    ) {
      saveSteps(formValue, props.masterStepValue, props.stepValue)
    }
    const tagManagerArguments = tagManagerArgs(
      props.draft.user_idFk,
      `${props.masterStepValue} - ${props.stepValue}`
    )
    TagManager.dataLayer(tagManagerArguments)
  }, [props.stepValue])

  const shiftRecheck = () => {
    const shiftedRecheck = _.slice(stepToRecheck, 1)
    if (!_.isEqual(stepToRecheck, shiftedRecheck)) {
      setStepToRecheck(shiftedRecheck)
    }
    return shiftedRecheck
  }

  const addValues = (values) => {
    addValue(values)
    _.each(values, (value, key) => {
      form.setFieldsValue({ [key]: value })
    })
  }
  const childrens = React.Children.map(props.children, (child) =>
    React.cloneElement(child, {
      size: componentSize,
      form,
      addValue,
      isEditing: props.editing,
      isBack: returnBack,
      goToStep: (subStep, masterStep) => {
        let toEdit = null
        if (masterStep !== null && masterStep !== undefined) {
          toEdit = substeps[masterStep].steps[subStep].onEdit || []
        } else {
          toEdit = substeps[props.masterStepValue].steps[subStep].onEdit || []
        }
        setStepToRecheck(toEdit)
        props.setEditing(true)
        props.goToStep(subStep, masterStep)
      },
      incrementStep: props.incrementStep,
      formValue,
      removeValue,
      loaderEnabled: handleLoaderEnabled,
    })
  )
  const handleOnFinish = propertyId ? modifyProperty : saveDraft
  const onFinish = async () => {
    setReturnBack(false)
    setLoadingIfEnabled(true)
    try {
      await handleOnFinish(
        formValue,
        addValue,
        draft,
        {
          masterStep: props.masterStepValue,
          subStep: props.stepValue,
        },
        props.editing
      )
    } catch (e) {
      setLoadingIfEnabled(false)
    }
    setLoadingIfEnabled(false)

    const shiftedStep = shiftRecheck()
    if (size(shiftedStep) === 0 && props.editing) {
      props.setEditing(false)
      props.goToRiepilogo()
    } else if (size(shiftedStep) > 0) {
      handleGoToStep(shiftedStep[0], step)
    } else {
      props.setEditing(false)
      props.incrementStep()
    }
  }
  const onBack = () => {
    props.decrementStep()
    setReturnBack(true)
  }
  const fieldsSkip = _(fields)
    .map((field) => _.size(formValue[field]) > 0)
    .reduce((res, field) => res || field)
  if (!formValue) {
    return null
  }

  return (
    <LoadingOverlay
      active={loading}
      spinner
      styles={{
        overlay: (base) => ({
          ...base,
          background: 'rgba(255, 255, 255, 0.80)',
          '& svg circle': {
            stroke: 'rgba(67, 159, 160, 1)',
          },
          color: 'rgba(67, 159, 160, 1)',
        }),
      }}
      text="Caricamento..."
    >
      <Form
        form={form}
        validateMessages={validateMessages}
        onValuesChange={addValue}
        initialValues={formValue}
        onFinish={onFinish}
        size={componentSize}
        className="relative"
      >
        {/* {(props.canDecrement && props.canIncrement) && (
          <Typography.Text onClick={onBack} className='flex items-center text-xl cursor-pointer'><LeftOutlined className='pr-2' />Indietro</Typography.Text>
        )} */}
        <Row className="pb-20 md:pb-0">
          {_.map(childrens, (child) => (
            <Col key={child.key} xs={24} className="py-2">
              {child}
            </Col>
          ))}
        </Row>
        <>
          {!btnDisabled && canSkip && !fieldsSkip ? (
            <SaltaButton
              stepText={`STEP ${getCurrentStep}/${countedStepsLenght}`}
            />
          ) : (
            !btnDisabled &&
            (props.editing ? (
              <Button
                text="Conferma Modifica"
                stepText={`STEP ${getCurrentStep}/${countedStepsLenght}`}
              />
            ) : (
              <>
                {props.canIncrement && (
                  <Button
                    text={bntLabel}
                    stepText={`STEP ${getCurrentStep}/${countedStepsLenght}`}
                  />
                )}
                {!props.canIncrement && (
                  <Button
                    text="Continua"
                    spaces="px-20"
                    stepText={`STEP ${getCurrentStep}/${countedStepsLenght}`}
                  />
                )}
              </>
            ))
          )}
        </>
      </Form>
    </LoadingOverlay>
  )
}

export default FormComponent
